import axios, { AxiosInstance, AxiosRequestConfig } from 'axios';
import urls from '../util/urls';
import {
  compose,
  withAccountHeader,
  withAuthHeader,
  withRetries,
  withConfiguredBaseUrl,
  withE2ERequestStubbing,
} from '../hooks/useService';
import { ServiceAuth } from '../hooks/useService/useService';

export default class PatientService {
  PatientAPI: (auth: ServiceAuth) => AxiosInstance;

  constructor(_options?: Partial<AxiosRequestConfig>) {
    this.PatientAPI = (auth: ServiceAuth) =>
      compose(
        withE2ERequestStubbing,
        withAccountHeader(auth.account),
        withAuthHeader(auth.authToken),
        withConfiguredBaseUrl(auth.config),
        withRetries(),
      )(axios.create());
  }

  fetchPatientsForProject =
    (auth: ServiceAuth) => async (projectId: string) => {
      return this.PatientAPI(auth).get(
        urls.api.patients.patientsForProject(projectId),
      );
    };

  uploadPatientFile =
    (auth: ServiceAuth) =>
    async ({
      id,
      file,
      subjectId,
      projectId,
      documentReference,
      contentType,
      name,
    }: {
      id: string;
      file: File;
      subjectId: string;
      projectId: string;
      name: string;
      contentType: string;
      documentReference: Partial<fhir.DocumentReference>;
    }) => {
      const response = await this.PatientAPI(auth).post(
        urls.api.patients.uploadPatientFile(projectId, subjectId),
        {
          id,
          file,
          name: name.replace(/\s+/g, '_'),
          datasetId: projectId,
          projectId: projectId,
          contentType: contentType,
          managedDocumentReference: true,
          attributes: {
            documentReference: documentReference,
            subject: subjectId,
            source: 'clinician-upload',
          },
        },
      );

      await axios.put(response.data.uploadUrl, await file.arrayBuffer());

      return response;
    };
}
